import FormInputWithCounter from './FormInputWithCounter';

export default FormInputWithCounter;
